/* eslint-disable jsx-a11y/alt-text */
import styled from 'styled-components';
import PdfViewer from '../PDFViewer';
import { useState } from 'react';

const FileViewer = ({ linkFile }) => {
    const [isLoaded, setIsLoaded] = useState(false);

    const typeFile = linkFile.split('.').pop();
    const filePpt = linkFile.includes('.ppt');

    if (!linkFile) {
        return (
            <div>
                <h3>Visualizador de Arquivos</h3>
                <p>nenhum arquivo selecionado.</p>
            </div>
        );
    }

    return (<div>
        {typeFile.includes("pdf") || typeFile.includes("txt") ?
            (<div>
                {/* {typeFile.includes("pdf") && <DivStyleDisabledDownload />} */}
                {/* <object data={linkFile.concat('#toolbar=0&navpanes=0&scrollbar=0"')} /> */}
                <PdfViewer url={linkFile} />
            </div>)
            :
            (<>
                <StyledFileViewer
                    src={`https://view.officeapps.live.com/op/embed.aspx?src=${linkFile}&ui=hidebuttons`}
                    onLoad={() => setTimeout(() => setIsLoaded(true), 450)}
                />
                {isLoaded && (
                    <DivStyleDisabledDownloadMicrosoft className={filePpt ? 'ppt-disable-buttons' : ''} />
                )}
                {/* <OfficeViewer url={linkFile} /> */}
            </>
            )
        }
    </div>);
};

export default FileViewer;

export const StyledFileViewer = styled.iframe`
    border-radius: 5px;
    width: 100% !important;    
    height: 75vmin!important;
`

export const DivStyleDisabledDownloadMicrosoft = styled.div`
    display: flex;
    float: right;
    margin-right: 3px;
    margin-top: -26px;
    position: relative;
    z-index: 9999;
    height: 20px !important;
    width: 150px !important;
    background-color: #ffffff;
`
export const DivStyleDisabledDownload = styled.div`
    height: 55px;
    width: 100%;   
    position: absolute;
    z-index:1;
    background-color:#f5f5f5;  
`